module.exports = __webpack_public_path__ + "static/media/delete_gray.760deb43.svg";